import { TextFieldFactory } from "./TextFieldFactory";

export const NumberField = (...args: any) => {
  return TextFieldFactory(
    {
      type: "text",
      parse: (v: any) => {
        const newV = v.replace(/[^\d]/g, "");
        if (newV === "") {
          return null;
        } else {
          return Number(newV);
        }
      }
    },
    ...args
  );
};
